import styled, {css} from 'styled-components';

import {getColor} from '@yourcoach/shared/styles/utils';
import {Button} from '@yourcoach/shared/uikit/Button';
import {Text} from '@yourcoach/shared/uikit/Text';
import {View} from '@yourcoach/shared/uikit/View';

export const Container = styled(View)`
  flex-direction: column;
`;

export const Tabs = styled(View)`
  border-bottom: 1px solid ${getColor('border2')};
`;

export const Tab = styled(Button)<{isActive: boolean}>`
  flex: 1;
  background: transparent;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  color: ${getColor('text3')};
  border-radius: 0;
  border-bottom: 2px solid transparent;

  &:hover {
    background: transparent;
    color: ${getColor('text6')};
    border-color: transparent;
  }

  ${p =>
    p.isActive &&
    css`
      color: ${getColor('text6')};
      border-color: ${getColor('global1')};

      &:hover {
        border-color: ${getColor('global1')};
      }
    `}
`;

export const Description = styled(Text)`
  font-size: 14px;
  line-height: 20px;
  color: ${getColor('text3')};
  margin: 20px 0 8px;
`;

export const SendCodeButton = styled(Button).attrs({size: 'l'})`
  margin-top: 20px;
`;
